// Used by Product Summary and BasketList components
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import moment from 'moment'
import ProductImage from '@components/ProductImage'
import DateRangeForm from '@components/DateRangeForm'
import './ProductListing.module.scss'
import { supportsWebp } from '../../helpers/webp'

const Product = ({ product, editMode, ...props }) => {
  const [format, setFormat] = useState('jpg')
  supportsWebp((isSupported) => {
    if (isSupported) {
      setFormat('webp')
    }
  })
  const title = R.prop('title', product)
  const productCode = R.prop('productCode', product)
  const ppe = R.propOr([], 'ppe', product)
  var image = R.prop('image', product)
  if (!image.includes('progressive')) {
    image = image + `&fm=${format}`
  }
  const quantity = R.prop('quantity', product)
  const startDate = R.prop('startDate', product)
  const endDate = R.prop('endDate', product)
  const ppeItems = `${ppe.join(', ')}.` || []

  return (
    <section styleName='container'>
      <div styleName='image'>
        <ProductImage src={image} alt={title} />
      </div>
      {editMode ? (
        <div styleName='info'>
          {title && <h5 styleName='title'>{title}</h5>}
          <div styleName='editItem'>
            <DateRangeForm {...props} />
          </div>
        </div>
      ) : (
        <div styleName='info'>
          {title && <h5 styleName='title'>{title}</h5>}
          <p>
            <span><b>Quantity:</b> {quantity}</span>
            <span><b>Product Code:</b> {productCode}</span>
            <span><b>Expected Hire Date:</b> {moment(startDate).format('D MMM YYYY')} - {moment(endDate).format('D MMM YYYY')}</span>
          </p>
          {R.not(R.isEmpty(ppe)) && (
            <p>
              <b>PPE needed:</b> {ppeItems}
            </p>
          )}
        </div>
      )}
    </section>
  )
}

Product.propTypes = {
  product: PropTypes.object.isRequired,
  editMode: PropTypes.bool,
  editProps: PropTypes.object
}

export default Product



// WEBPACK FOOTER //
// ./src/components/ProductListing/ProductListing.js